// src/utils/authManager.js
import Cookies from 'js-cookie';

// Cookie 中的 Token Key
const TOKEN_KEY = 'Admin-Token';

/**
 * 检查登录状态
 * @returns {Promise<Object>} 登录状态对象
 */
export async function checkLoginStatus() {
  // 在 App 环境中，优先从 JSBridge 获取登录状态
  if (window.jsBridge && window.jsBridge.isInApp) {
    try {
      const userInfo = await window.jsBridge.getUserInfo();
      if (userInfo && userInfo.token) {
        return {
          isLoggedIn: true,
          token: userInfo.token,
          userId: userInfo.userId || null,
          source: 'jsbridge'
        };
      }
    } catch (error) {
      console.warn('从JSBridge获取登录状态失败:', error);
    }
  }
  
  // 检查 Cookie 中的登录状态（主要用于浏览器环境）
  const token = Cookies.get(TOKEN_KEY);
  
  // 如果 Cookie 中没有 token，尝试从 JSBridge 获取（用于浏览器环境）
  if (!token && window.jsBridge) {
    try {
      const userInfo = await window.jsBridge.getUserInfo();
      if (userInfo && userInfo.token) {
        return {
          isLoggedIn: true,
          token: userInfo.token,
          userId: userInfo.userId || null,
          source: 'jsbridge'
        };
      }
    } catch (error) {
      console.warn('从JSBridge获取登录状态失败:', error);
    }
  }
  
  return {
    isLoggedIn: !!token,
    token: token || null,
    userId: null, // 浏览器环境中可能需要其他方式获取用户ID
    source: 'cookie'
  };
}

/**
 * 处理未登录状态
 * @param {Function} routerPush - 路由跳转函数
 */
export async function handleUnauthenticated(routerPush) {
  // 在浏览器中，跳转到登录页面
  if (routerPush) {
    routerPush('/login');
  }
}

/**
 * 设置 Token
 * @param {string} token - 认证令牌
 */
export function setToken(token) {
  // 在浏览器环境中，保存到 Cookie
  if (!window.jsBridge || !window.jsBridge.isInApp) {
    Cookies.set(TOKEN_KEY, token);
  }
  // 在 App 环境中，Token 由 App 管理，不需要保存到 Cookie
  // 这里可以添加 App 环境下的特殊处理（如果需要）
  console.log('Token 设置成功:', token);
}

/**
 * 获取 Token
 */
export function getToken() {
  // 在 App 环境中，从全局登录状态获取 Token
  if (window.jsBridge && window.jsBridge.isInApp) {
    // 从全局状态中获取 Token（如果存在）
    if (window.globalAuthState && window.globalAuthState.token) {
      return window.globalAuthState.token;
    }
    // 这里也可以直接返回 null，因为在 App 环境中，
    // 请求拦截器会从 JSBridge 中获取最新的 Token
    return null;
  }
  // 在浏览器环境中，从 Cookie 获取
  return Cookies.get(TOKEN_KEY);
}

/**
 * 移除 Token
 */
export function removeToken() {
  // 在浏览器中，只从 Cookie 移除
  Cookies.remove(TOKEN_KEY);
}

